const HOME = {
  TO_MY_PRESENTATION_LIST: 'Home > My Presentations List',
  TO_TEMPLATE_LIBRARY: 'Home > Templates > Browse all',
  SEE_MORE_NOTIFICATIONS: 'Home > Noti > See more notifications',
  JOIN_COMMUNITY: 'Home > Join the community',
  READ_FEEDBACK: 'Home > Feedback > Click to read',
  READ_NOTIFICATION: 'Home > Noti > Click to read',
  CLICK_WHATS_NEW_ITEM: "Home > What's New > Click to read",
}

export {
  HOME,
}
